export { default } from './Static';
